import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UnsubscribeSuccessComponent } from '@se-po/se-household-setup-feature-unsubscribe-success'
import { GuardianInviteGuardService } from './guardian-invite/guardian-invite-guard.service'
import { GuardianInviteComponent } from './guardian-invite/guardian-invite.component'
import { SetupMembershipComponent } from './setup-membership/setup-membership.component'

const routes: Routes = [
  { path: '', redirectTo: 'household', pathMatch: 'full', },
  { path: 'account', redirectTo: 'household', pathMatch: 'prefix', },
  {
    path: 'guardian-invite/:id/accept',
    canActivate: [
      GuardianInviteGuardService
    ],
    component: GuardianInviteComponent
  },
  {
    path: 'household',
    loadChildren: () => import('./create-household/create-household.module')
      .then(m => m.CreateHouseholdModule)
  },
  {
    path: 'membership',
    component: SetupMembershipComponent
  },
  {
    path: 'mfa-onboarding',
    loadChildren: () => import('./mfa-onboarding/mfa-onboarding.module')
      .then(m => m.MfaOnboardingModule)
  },
  {
    path: 'minor-account',
    loadChildren: () => import('./minor-account/minor-account.module')
      .then(m => m.MinorAccountModule)
  },
  {
    path: 'unsubscribe-success',
    component: UnsubscribeSuccessComponent
  },
  {
    path: '**',
    redirectTo: 'household',
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
